import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/Guest-blank.webp";
import ThumbImg from "../../assets/images/conversations/blank.png";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: sc-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .sc-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }

  .sc-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ══════════════════════════════════════
     SECTION 1 - HERO
  ══════════════════════════════════════ */
  .sc-hero {
    padding-top: 60px;
    padding-bottom: 60px;
  }
  .sc-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .sc-hero__left {
    display: flex;
    flex-direction: column;
    gap: 44px;
  }
  .sc-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sc-hero__title.sc-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .sc-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .sc-hero__spotify.sc-visible {
    opacity: 1;
    transform: translateY(0);
  }
  .sc-hero__spotify iframe {
    display: block;
    width: 100%;
    height: 152px;
    border: none;
    border-radius: 12px;
  }
  .sc-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .sc-hero__right.sc-visible {
    opacity: 1;
    transform: translateY(0);
  }

  /* thumbnail */
  .sc-yt-thumb {
    position: relative;
    width: 100%;
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    display: block;
    background: #000;
  }
  .sc-yt-thumb img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 12px;
    transition: opacity 0.3s ease;
  }
  .sc-yt-thumb:hover img { opacity: 0.85; }
  .sc-yt-thumb__play {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }
  .sc-yt-thumb__play img {
    width: 40px;
    height: 44px;
  }
  .sc-yt-iframe-wrap {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    border-radius: 12px;
    overflow: hidden;
  }
  .sc-yt-iframe-wrap iframe {
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border: none;
  }

  /* ══════════════════════════════════════
     SECTION 2 - BODY
  ══════════════════════════════════════ */
  .sc-body {
    padding-bottom: 100px;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sc-body.sc-visible { opacity: 1; transform: translateY(0); }
  .sc-body__para {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 14px;
  }
  .sc-body__para:last-child { margin-bottom: 0; }
  .sc-body__lead {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
    margin-bottom: 4px;
  }
  .sc-body__list {
    list-style: none;
    margin: 0 0 4px;
    padding: 0;
  }
  .sc-body__list li {
    position: relative;
    padding-left: 18px;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #E2E2E2;
    line-height: 160%;
  }
  .sc-body__list li::before {
    content: "•";
    position: absolute;
    left: 0;
    color: #E2E2E2;
  }

  /* ══════════════════════════════════════
     SECTION 3 - OUR GUEST (1 guest)
  ══════════════════════════════════════ */
  .sc-guest {
    padding-bottom: 100px;
    text-align: center;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .sc-guest.sc-visible { opacity: 1; transform: translateY(0); }
  .sc-guest__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 60px;
  }
  .sc-guest__photo-bg {
    display: inline-block;
    width: 445px;
    height: 500px;
    background: #743FAC;
    border-radius: 12px;
    overflow: hidden;
  }
  .sc-guest__photo-bg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top center;
    display: block;
  }
  .sc-guest__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .sc-inner { padding-left: 32px; padding-right: 32px; }
    .sc-hero { padding-top: 32px; padding-bottom: 48px; }
    .sc-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .sc-hero__title { font-size: 24px; }
    .sc-hero__left { gap: 16px; }
    .sc-guest__title { font-size: 24px; margin-bottom: 24px; }
    .sc-guest__photo-bg { width: 260px; height: 300px; }
    .sc-guest__name { font-size: 24px; margin-top: 18px; }
    .sc-body__para { font-size: 14px; margin-bottom: 12px; }
    .sc-body__lead { font-size: 14px; }
    .sc-body__list li { font-size: 14px; }
    .sc-body { padding-bottom: 48px; }
    .sc-guest { padding-bottom: 48px; }
    .sc-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .sc-inner { padding-left: 16px; padding-right: 16px; }
    .sc-hero { padding-top: 51px; padding-bottom: 30px; }
    .sc-hero__grid { grid-template-columns: 1fr; gap: 40px; }
    .sc-hero__left { gap: 30px; }
    .sc-hero__title { font-size: 30px; }
    .sc-body__para { font-size: 16px; margin-bottom: 10px; }
    .sc-body__lead { font-size: 16px; }
    .sc-body__list li { font-size: 16px; }
    .sc-guest__title { font-size: 30px; margin-bottom: 20px; text-align:left; }
    .sc-guest__photo-bg { width: 100%; height: 386px; }
    .sc-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .sc-body { padding-bottom: 30px; }
    .sc-guest { padding-bottom: 30px; }
    .sc-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

/* ─────────────────────────────────────────────
   FADE-UP HOOK
───────────────────────────────────────────── */
function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("sc-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

/* ─────────────────────────────────────────────
   YOUTUBE EMBED
───────────────────────────────────────────── */
const YT_VIDEO_ID = "YOUTUBE_VIDEO_ID";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);

  if (playing) {
    return (
      <div className="sc-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 65 Sudhakar Chirra"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <div className="sc-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 65 Sudhakar Chirra thumbnail" />
      <div className="sc-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   SECTIONS
───────────────────────────────────────────── */
function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);

  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="sc-hero">
      <div className="sc-inner">
        <div className="sc-hero__grid">
          <div className="sc-hero__left">
            <h1 ref={titleRef} className="sc-hero__title">
              EP 65 | FreshBus: Driving India's Intercity Travel Electric | Sudhakar CHIRRA
            </h1>
            <div ref={spotifyRef} className="sc-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/53GGJdS0x06pXo1AP2yBHp?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 65 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="sc-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="sc-body">
      <div className="sc-inner">
        <p className="sc-body__para">
          Welcome to the Energizing India Podcast! On this program, we engage with the key protagonists shaping the future of energy, mobility, and sustainability in India and globally. I'm your host, Ravin MIRCHANDANI, and today we're stepping into a completely new lane of India's transport story in relation to zero-emission intercity travel going electric. We're talking about FreshBus, a young but ambitious player redefining what it means to move people cleanly, comfortably, and efficiently across states.
        </p>
        <p className="sc-body__para">
          Joining us is Mr. Sudhakar CHIRRA, a serial entrepreneur synonymous with innovation in India's bus mobility space. Before FreshBus, he founded and led AbhiBus, India's first bus-ticketing app that reshaped how travelers connect with operators.
        </p>
        <p className="sc-body__para">
          Now he heads FreshBus, an all-electric, full-stack intercity bus platform that's rewriting expectations of cost, speed, and sustainability in mobility. Since launching in 2019, FreshBus has built a battery-powered fleet, carried hundreds of thousands of passengers, and is now backed by a $10.5 million Series A round to scale that ambition nationwide.
        </p>
        <p className="sc-body__lead">With Sudhakar as our guide, today we'll explore:</p>
        <ul className="sc-body__list">
          <li>What does it mean to start fresh with a 100% electric fleet?</li>
          <li>How does one build profitability in a capital-intensive asset under real Indian conditions?</li>
          <li>What's the passenger experience really like when "EV+Tech" replaces convention?</li>
        </ul>
        <p className="sc-body__para">Sudhakar, welcome to the program.</p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);

  return (
    <section ref={ref} className="sc-guest">
      <div className="sc-inner">
        <h2 className="sc-guest__title">Our Guest</h2>
        <div>
          <div className="sc-guest__photo-bg">
            <img src={GuestImg} alt="Sudhakar Chirra" />
          </div>
          <p className="sc-guest__name">Sudhakar CHIRRA</p>
        </div>
      </div>
    </section>
  );
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function Ep65SudhakarChirra() {
  return (
    <>
      <style>{CSS}</style>
      <div className="sc-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}